export default __webpack_public_path__ + "static/media/Samirs_image.60891654.jpg";